// extracted by mini-css-extract-plugin
export default {"offerItem":"OfferItems_offerItem__P2mwa","offerItem1":"OfferItems_offerItem1__WIYA7","offerItem2":"OfferItems_offerItem2__3MEGQ"};